import React from 'react';
import '../css/Job.css';
import htmlImg from '../img/html.png';
import pencil from '../img/pencil.png';
import design from '../img/ux-design.png';
import internet from '../img/internet.png'

function Job() {
    return (
        <div className="job" id="whatido">
            <div className="job__title">
                <h1>What I Do</h1>
                <hr />
            </div>
            
            <div className="job__services">
                <div className="row">
                    <div className="col-2">
                        <div className="head">
                            <img src={htmlImg} alt="" />
                            <h2>WEB DEVELOPMENT</h2>
                        </div>
                        <p>Using HTML, CSS, and JavaScript with pre-processors and build tools such as Sass and Grunt, I have a passion for developing pixel-perfect websites and apps while maintaining a semantic, modular, and DRY code base.</p>
                    </div>
                    <div className="col-2">
                        <div className="head">
                            <img src={pencil} alt="" />
                            <h2>Responsive ui design</h2>
                        </div>
                        <p> <span style={{fontWeight: 'bold'}}>"A user interface is like a joke. If you have to explain it, it's not that good."</span>  I strive to develop and implement responsive and aesthetically pleasing interfaces for websites and apps that adapt to any type of device, platform, or browser.</p>
                    </div>
                </div>

                <div className="row">
                    <div className="col-2">
                        <div className="head">
                            <img src={design} alt="" />
                            <h2>Experience Design</h2>
                        </div>
                        <p>There have been far too many times where I've been trying to accomplish a simple task on a website, and ended up wanting to throw my computer out the window in frustration. Needless to say, user experience is an aspect of software I believe is vital to a successful product.</p>
                    </div>
                    <div className="col-2">
                        <div className="head">
                            <img src={internet} alt="" />
                            <h2>Backend development</h2>
                        </div>
                        <p>Using Php and sometimes Java I love to build web applications. But the most thing I like is Front End Development I love to make users looking on my pages for a while!</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Job;
